import { Stack, StackPage, StackSwitch, usePersistedStateId } from "@comet/admin";
import PageTitle from "@src/components/headers/PageTitle";
import { FormattedMessage } from "react-intl";

import { EditUser } from "./edit/User";
import Table from "./Table";
import UsersSummary from "./UsersSummary";

export default () => {
    const persistedStateId = usePersistedStateId();
    return (
        <Stack topLevelTitle={<FormattedMessage id="reviermanager.page.users.main" defaultMessage="Alle Kunden" />}>
            <StackSwitch initialPage="table">
                <StackPage name="table">
                    <PageTitle>
                        <FormattedMessage id="reviermanager.page.users.main" defaultMessage="Alle Kunden" />
                    </PageTitle>
                    <UsersSummary />
                    <Table persistedStateId={persistedStateId} />
                </StackPage>
                <StackPage name="edit" title={<FormattedMessage id="reviermanager.pages.users.edit" defaultMessage="Kunde bearbeiten" />}>
                    {(id) => <EditUser id={id} />}
                </StackPage>
            </StackSwitch>
        </Stack>
    );
};
